module.exports = __webpack_public_path__ + "img/apple_icon.bde5ba5f.svg";